var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-dialog',{staticClass:"confirm-dialog",model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_c('p',[_vm._v("认证成功")]),_c('button',{on:{"click":_vm.jump2activity}},[_vm._v(" "+_vm._s(_vm.$theme.successDialogBtnLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }